export default __webpack_public_path__ + "static/media/100_6213.a2d28094.jpg";